// extracted by mini-css-extract-plugin
export default {"Container":"ConversationInfoLayout_Container__ZVs6P","Label":"ConversationInfoLayout_Label__--9LB","Content":"ConversationInfoLayout_Content__FSygH"};